import type { HackSymptom } from '@domain/models/pd-hacks'
import { buildBreadcrumbList } from '@presentation/seo/StructuredDataBuilders'
import { toAbsoluteUrl } from '@presentation/seo/seo-constants'

type StructuredDataNode = Record<string, unknown>

interface BuildHackStructuredDataInput {
  hack: HackSymptom
  canonicalPath: string
  hackTitle: string
  hackDescription: string
  ogImageUrl?: string
}

function normalizeOptionalString(value: string | undefined): string | undefined {
  const normalized = value?.trim()
  return normalized && normalized.length > 0 ? normalized : undefined
}

export function buildHackStructuredData({
  hack,
  canonicalPath,
  hackTitle,
  hackDescription,
  ogImageUrl,
}: BuildHackStructuredDataInput): StructuredDataNode[] {
  const canonicalUrl = toAbsoluteUrl(canonicalPath)
  const normalizedVideoId = normalizeOptionalString(hack.videoId)
  const normalizedImageUrl = normalizeOptionalString(ogImageUrl)
  const uploadDate = hack.videoPublishedAt ?? hack.createdTime

  const schemas: StructuredDataNode[] = [
    buildBreadcrumbList([
      { name: 'Home', pathOrUrl: '/' },
      { name: "Michel's PD Hacks", pathOrUrl: '/hacks' },
      { name: hackTitle, pathOrUrl: canonicalPath },
    ]),
  ]

  if (normalizedVideoId) {
    schemas.push({
      '@context': 'https://schema.org',
      '@type': 'VideoObject',
      name: hackTitle,
      description: hackDescription,
      url: canonicalUrl,
      uploadDate: uploadDate?.toISOString(),
      thumbnailUrl: normalizedImageUrl ? [toAbsoluteUrl(normalizedImageUrl)] : undefined,
      embedUrl: `https://www.youtube.com/embed/${normalizedVideoId}`,
      contentUrl: `https://www.youtube.com/watch?v=${normalizedVideoId}`,
    })
  }

  return schemas
}
